import React from 'react';
import {Redirect, useLocation} from 'react-router-dom';

import {safeLocalStorage} from '../../../../../../core/util/localStorage';
import {
  getDefaultViewId,
  makeSavedViewLocalStorageKey,
} from '../SavedViews/savedViewUtil';

type RedirectToLastViewProps = {
  entity: string;
  project: string;
  tab: string;
};

export const RedirectToLastView = ({
  entity,
  project,
  tab,
}: RedirectToLastViewProps) => {
  const location = useLocation();

  // Traces table might be under 'calls'
  const viewType = tab === 'evaluations' ? 'evaluations' : 'traces';
  const localStorageKey = makeSavedViewLocalStorageKey(
    entity,
    project,
    viewType
  );
  const defaultView = getDefaultViewId(viewType);
  const lastView = safeLocalStorage.getItem(localStorageKey) ?? defaultView;

  // Create a new URLSearchParams object from the current query parameters
  const searchParams = new URLSearchParams();
  searchParams.set('view', lastView);

  // Return the Redirect component to navigate to the updated URL
  return <Redirect to={`${location.pathname}?${searchParams.toString()}`} />;
};
